export default __webpack_public_path__ + "static/stitch-fa8684aa9487154f9b0cad97b95cdeaa.jpg";